import { type FC, useState } from "react"
import { type Control, Controller, type FieldValues } from "react-hook-form"
import InputMask from "react-input-mask"

export const InputField: FC<{
  name: string
  type?: string
  mask?: string
  className?: string
  placeholder: string
  onFocus?: () => void
  error: string | undefined
  control: Control<FieldValues, any>
  additionalProps?: Record<string, any>
  additionalState?: string
  errorInFlow?: boolean
  // Optional title label (unused in UI but kept for compatibility)
  title?: string
}> = ({
  name,
  error,
  control,
  onFocus,
  mask = "",
  type = "text",
  className = "",
  placeholder = "...",
  additionalState = "",
  additionalProps = {},
  errorInFlow = false,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(true)

  // Extract custom onChange from additionalProps
  const { onChange: customOnChange, ...restAdditionalProps } = additionalProps

  return (
    <div className="relative w-full">
      <div className="relative">
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange: fieldOnChange } }) => (
            <div>
              <InputMask
                {...restAdditionalProps}
                className={`h-12 px-4 border w-full text-body-lg placeholder-[#232734] placeholder-opacity-50 rounded-[4px] outline-none ${className} ${
                  error
                    ? "border-[#FF1C5E] text-error"
                    : "border-[#232734] border-opacity-50 focus:border-opacity-100"
                }`}
                mask={mask}
                maskChar=" "
                onChange={(e) => {
                  // Call the field's onChange first to update form state
                  fieldOnChange(e)
                  // Then call the custom onChange if provided
                  if (customOnChange && typeof customOnChange === "function") {
                    ;(customOnChange as (e: React.ChangeEvent<HTMLInputElement>) => void)(e)
                  }
                }}
                onFocus={onFocus}
                placeholder={placeholder}
                type={passwordVisible ? type : "text"}
                value={value as string}
              />
              {!!additionalState && (
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[11px] leading-3 text-[#232734] text-left">
                  {additionalState}
                </span>
              )}
            </div>
          )}
        />

        {/* Show/Hide password button */}
        {type === "password" && (
          <button
            className={`text-[13px] absolute right-4 top-1/2 transform -translate-y-1/2 bg-white ${
              passwordVisible ? "text-[#232734]" : "text-[#a8aaac]"
            }`}
            onClick={() => setPasswordVisible((state) => !state)}
            type="button"
          >
            see pass
          </button>
        )}
      </div>
      {!!error && (
        <span
          className={`first-letter:uppercase text-body-sm text-error ${
            errorInFlow ? "mt-1 block" : "absolute left-0 top-full"
          }`}
        >
          {error}
        </span>
      )}
    </div>
  )
}
